import React from 'react'
import Splash from '../../components/Splash'
import getMessage from '../../lib/getMessage'

const MessageCenter = props =>
  <Splash>
    {getMessage(props.match.params.messageCode).text}
  </Splash>

export default MessageCenter
